import React, { ReactNode, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FullScreenIcon, ExitFullScreen } from '../../assets';
import CloseIcon from '../../assets/images/closeIcon.svg';

import { setFullScreenModalOpen } from '../../features/FullScreenModal/FullScreenModalSlice';
import { Tooltip } from 'antd';
import { handlePageChange } from '../../utils/readiumUtils';
import { setFullScreenModeEnabled } from '../../features/FullScreenMode/fullScreenMode';
import { RootState } from '../../store';

interface ModalProps {
    title?: string;
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    footerButtons?: ReactNode[];
}

const FullScreenModal: React.FC<ModalProps> = ({
    title,
    isOpen,
    onClose,
    children,
    footerButtons,
}) => {
    const dispatch = useDispatch();
    const isFullScreen = useSelector(
        (state: RootState) => state.FullScreenMode.isEnabled
    );
    const enterFullScreen = () => {
        const doc = document.documentElement;
        doc.requestFullscreen();
        dispatch(setFullScreenModeEnabled(true));
    };

    const handleCloseClick = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
        dispatch(setFullScreenModeEnabled(false));
        onClose();
    };
    const exitFullScreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
            dispatch(setFullScreenModeEnabled(false));
        }
    };
    // Monitor fullscreen state changes
    useEffect(() => {
        const handleFullScreenChange = () => {
            if (document.fullscreenElement === null) {
                dispatch(setFullScreenModeEnabled(false));
            } else {
                dispatch(setFullScreenModeEnabled(true));
            }
        };

        document.addEventListener('fullscreenchange', handleFullScreenChange);

        return () => {
            document.removeEventListener(
                'fullscreenchange',
                handleFullScreenChange
            );
        };
    }, []);

    useEffect(() => {
        dispatch(setFullScreenModalOpen(true));
        return () => {
            dispatch(setFullScreenModalOpen(false));
        };
    }, []);
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full">
            <div className=" flex flex-col w-full h-full items-center">
                <div className="fixed top-0 right-0 flex justify-end items-start gap-4 p-4 z-50">
                    <button
                        onClick={handleCloseClick}
                        className="focus:outline-none absolute right-6  py-2 min-w-[3rem]"
                        title="Close"
                        data-testid="close-full-screen-modal-button"
                    >
                        <img src={CloseIcon} alt="Close Button" />
                    </button>
                    <Tooltip
                        title={isFullScreen ? 'Exit Fullscreen' : 'Fullscreen'}
                        placement="top"
                    >
                        <button
                            data-testid="fullscreen-button"
                            onClick={
                                isFullScreen ? exitFullScreen : enterFullScreen
                            }
                            className="absolute w-[2.5rem] min-w-[2.5rem]  py-2 rounded-lg right-20"
                        >
                            <img
                                src={
                                    isFullScreen
                                        ? ExitFullScreen
                                        : FullScreenIcon
                                }
                                alt="fullscreen"
                            />
                        </button>
                    </Tooltip>
                </div>

                <div className="w-[100%] h-full rounded-[1.5rem]">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default FullScreenModal;
